import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import LoadingButton from './LoadingButton';
import clsx from "clsx";
import { getDisplayName } from '../utils'

const ConfirmationModal = ({
  className,
  isOpen,
  hasSucceed,
  isLoading,
  onConfirm,
  confirmText,
  onCancel,
  cancelText,
  participants,
  question,
  QuestionComponent,
  QuestionComponentProps,
  simple,
  ...props
}) => {
    const { t } = useTranslation('common')
    if (!isOpen) {
      return null
    }

    const renderSucceedMessage = () => {
      return (
        <ModalBody className="d-flex flex-column justify-content-center align-items-center">
          {t('successMessages.documentSent')}
          <FontAwesomeIcon className="mt-2" icon="check-circle" size="2x" style={{color: "green"}} />
        </ModalBody>
      )
    }

    const renderLoadingMessage = () => {
      return (
        <ModalBody className="text-center d-flex flex-column align-items-center justify-content-center">
          {t('actions.sending')}
          <Spinner color="accent" className="d-block" />
        </ModalBody>
      )
    }

    const renderDialog = () => {
      return (
        <>
          <ModalHeader toggle={onCancel} className="text-center">
            {participants && <Question participants={participants}>{question}{" "}</Question>} 
            {QuestionComponent && <QuestionComponent {...QuestionComponentProps} />}
            {!participants && !QuestionComponent && question}
          </ModalHeader>
          <ModalFooter className="mx-auto border-0">
            { cancelText && <Button color="btn btn-primary" onClick={onCancel}>{cancelText}</Button> }
            <LoadingButton loading={isLoading} loadingText={t('actions.loading')} color="btn btn-accent" onClick={() => onConfirm()}>{confirmText}</LoadingButton>
          </ModalFooter>
        </>
      )
    }
  
    return (
      <Modal isOpen={isOpen} toggle={onCancel} centered 
        className={clsx({ className: true, "justify-content-center": hasSucceed || isLoading})}
        size={!simple && (hasSucceed || isLoading) ? 'sm' : 'md'}
      > 
        {
          !simple && hasSucceed ? renderSucceedMessage() :
          !simple && isLoading ? renderLoadingMessage() :
          renderDialog()
        }  
      </Modal>
    );
  }

  function Question({children, participants}) {
    const { t } = useTranslation('common')
    const Text = ({children}) => (<span className="text-accent">{children}</span>)
    
    return (
      <div className="px-1">
        {children} 
        {
          participants.map((participant, i) => (
            <React.Fragment key={participant._id}>
              { i === participants.length - 1 &&   participants.length > 1 && ` ${t('and')} `}
              { i === 0 &&  ""}
              { i > 0 && i < participants.length - 1 &&  ",  "}
              <Text key={participant._id}>
                {
                  participant.obligation === 'individual' ? 
                    getDisplayName(participant.name, participant.last_name) 
                    : getDisplayName(participant.name)
                }
              </Text>
            </React.Fragment>
          ))
        }
        ?
      </div>
    )
  }
  
  export default ConfirmationModal;
